const config = {
  DATA_SET: process.env.REACT_APP_DATASET,
  baseUrl: 'https://myservices.mass.gov/iee/',
  azureInfo: {
    clientId: '77141fa8-88b4-48db-9607-26a9f84f30e4',
    massGov: 'https://login.mass.gov/a1a3107f-6bd6-4b8c-8324-51e880cdee7c/b2c_1a_v2_sisu_iee',
    massGovB2C: 'https://login.mass.gov',
    msauthRedirectURI: 'https://myservices.mass.gov'
  },

  API_VERSION: 'api/v1/',
  token: '',
  pageLimit: 10,
  idleTimeout: '1200000',
  languages: [
    { key: 'English', value: 'en-US' },
    { key: 'Español', value: 'es-ES' },
    { key: 'Português', value: 'pt-BR' },
    { key: '中文', value: 'zh-Hans' },
    { key: 'Tiếng Việt', value: 'vi-VI' },
    { key: 'Kreyòl ayisyen', value: 'cy-HT' }
  ],
  utilityDiscountURL: 'https://myservices.mass.gov/iee-utility-opt/api/v1/opt-out',
  endpoints: {},
  fontfamily: '"Source Sans Pro", sans-serif',
  font16: '16px',
  font18: '18px',
  colors: {
    white: '#FFFFFF',
    aliceblue: '#EBF4FA',
    mildyellow: '#fef9e8',
    darkblue: '#002a57',
    black: '#000000',
    tangaroa: '#001e3e',
    blueprimary: '#002a57',
    btnBlue: '#005974',
    verylightshadegray: '#fafafa',
    lightgrey: '#f2f2f2',
    grey: 'rgba(117,117,117,0.2)',
    darkgray: '#535353',
    green: '#388557',
    lightblue: '#dff2ff',
    chinesesilver: '#ccc',
    blue: '#1976d2',
    yellow: '#f1c11a',
    sonicSliver: '#757575',
    prussianBlue: '#002A57',
    pastelBlue: '#b3bfcd',
    lightBlue: '#669bac',
    red: '#FF0000',
    davyGrey: '#5A5A5A',
    grayColor: 'gray',
    mildBlue: '#f4fbfe'
  },
  bordergray: { border: '1px solid #ccc' },
  p0: { padding: '0' },
  p00: { padding: '0 .75rem' },
  p07: { padding: '.75rem' },
  margin: '0 auto',
  m0: { margin: 0 },
  mt03: { marginTop: '0.3rem' },
  mt15: { marginTop: '1.5rem' },
  mr05: { marginRight: '0.5rem' },
  w65: { width: '65%' },
  w95: { width: '95%' },
  w100: '100%',
  w20: '20rem',
  w100p: { width: '100%' },
  width78: { width: '78rem' },
  width59: { width: '59.7rem' },
  width51: { width: '51.7rem' },
  width64: { width: '64rem' },
  maxW200: { maxWidth: '200px' },
  minW24: { minWidth: '24px' },
  minW35: { minWidth: '35px' },
  height37: '37px',
  height29: '29px',
  height44: { height: '44px' },
  height3: { height: '3.4375rem' },
  z: { zIndex: '9999' },
  cursorpointer: { cursor: 'pointer' },
  overflowY: { overflowY: 'auto' },
  liststyle: { listStyle: 'none' },
  fontSize16: { fontSize: '16px' },
  navUrls: {
    massHealthUrl: 'https://www.mass.gov/orgs/masshealth',
    dtaConnectUrl: 'https://dtaconnect.eohhs.mass.gov',
    contactUs: 'https://www.mass.gov/info-details/contact-masshealth-information-for-members#masshealth-member-customer-service-center-',
    sitePolicies: 'https://www.mass.gov/lists/eohhs-site-policies',
    accessibility: 'https://www.mass.gov/policy-advisory/enterprise-information-technology-accessibility-policy',
    massHealthTopics: 'https://www.mass.gov/topics/masshealth',
    mahixLogin: 'https://mahix.org/individual/login',
    healthConnector: 'https://login.mahix.org/oidc/authorize?client_id=3bafe1b6747460e51e62b2298800663364933ad3831db166&response_type=code&scope=openid+profile+email+address+phone&redirect_uri=https://mahix.org/individual/login',
    healthChoices: 'https://masshealthchoices.com/en',
    massHealthForIndividuals: 'https://www.mass.gov/how-to/apply-for-masshealth-the-health-safety-net-or-the-childrens-medical-security-plan',
    massHealthForSeniors: 'https://www.mass.gov/how-to/apply-for-masshealth-coverage-for-seniors-and-people-of-any-age-who-need-long-term-care-services',
    mhEstimate: 'https://malink.co/get-an-estimate',
    mahixIndi: 'https://www.mahix.org/individual/',
    mhSchedule: 'https://www.mass.gov/info-details/schedule-an-appointment-with-a-masshealth-representative',
    mahixIndiLogin: 'https://mahix.org/individual/account/dashboard',
    reportChangesToMasshealth: 'https://www.mass.gov/how-to/report-changes-to-masshealth',
    massExeOffice: 'https://www.mass.gov/orgs/executive-office-of-health-and-human-services',
    massUserPanel: 'https://www.mass.gov/user-panel?utm_source=survey',
    learnMyServicesURL: 'https://www.mass.gov/info-details/learn-about-myservices',
    privacyNotices: 'https://www.mass.gov/info-details/masshealth-member-privacy-information',
    termsAndConditions: 'https://www.mass.gov/info-details/massgov-terms-of-use',
    smsTermsAndConditionsURL: 'https://falcon.ehs.mass.gov/ehs/masshealth/smstermsofservice-{lang}.html',
    requestMassHealthCard: 'https://www.mass.gov/how-to/request-a-masshealth-card',
    mhVerificationList: 'https://www.mass.gov/info-details/masshealth-and-health-connector-acceptable-verifications-list',
    renewMHCoverage: 'https://www.mass.gov/how-to/renew-your-masshealth-coverage',
    ssaLink: 'https://www.mass.gov/handbook/enterprise-information-security-policies-and-standards',
    adobeDownload: 'https://get.adobe.com/reader/'
  },
  translationAvailable: ['en-US', 'es-ES'],
  translationAvailableUtility: ['en-US'],
  featureToggle: {
    utilityDiscountProgram: true,
  },
  // environmentVar_key:'production',
  // environmentVar_key:'qa',
  environmentVar_key: 'production',
  GA4_KEY: 'G-X38F8Q9ZBL'
}

export default config
